import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import i18n from "../i18n";

const supportedLngs = ["en", "de", "el", "fr", "it", "ru"];

export default function MainLayout() {
  const { lang } = useParams();
  const navigate = useNavigate();

  useEffect(() => {

    // Missing language
    // if (!lang) {
    //   const savedLang = localStorage.getItem("lang") || "en";

    //   navigate(`/${savedLang}`, { replace: true });
    //   return;
    // }

    // Invalid language
    if (!supportedLngs.includes(lang)) {
      navigate("/en", { replace: true });
      return;
    }

    // Sync i18n
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }

    localStorage.setItem("lang", lang);

  }, [lang]);

  // Prevent rendering before lang is resolved
  if (!lang || !supportedLngs.includes(lang)) {
    return null;
  }

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}